import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconArrowUpWithColorComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-ArrowUpWithColor${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path fillRule="evenodd" clipRule="evenodd" d="M4.26879 0.79651C4.1358 0.622428 3.87392 0.621759 3.74005 0.795159L0.800865 4.60221C0.631693 4.82133 0.787886 5.13924 1.06472 5.13924H2.64421V8.99878C2.64421 9.18288 2.79345 9.33212 2.97754 9.33212H4.97754C5.16163 9.33212 5.31087 9.18288 5.31087 8.99878L5.31087 5.13924H6.91215C7.18819 5.13924 7.34461 4.82292 7.17704 4.60356L4.26879 0.79651Z" fill={useCurrentColor ? 'currentColor' : '#009E3D'}/></svg>;
}

const IconArrowUpWithColor = React.forwardRef(IconArrowUpWithColorComponent);
export default IconArrowUpWithColor;
